import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import BookingBanner from '../components/BookingBanner'

export default function PhoneTreatmentPage() {
  return (
    <>
      <MetaTags
        title="Behandling over telefon - Trine Rosendal"
        description="Behandling over telefon: 60 min: 900kr, 120 min: 1100kr. Samtale/intuitiv vejledning kombineret med fjernhealing over telefon."
        image="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1020-scaled.jpg"
        canonicalUrl="https://trine-rosendal.dk/telefonisk-behandling"
      />

      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-8 sm:py-14 space-y-12 sm:space-y-16">
        {/* Header Introduction */}
        <div className="max-w-3xl space-y-4">
          <nav aria-label="Brødkrummer" className="flex items-center gap-2 text-xs text-[#7A6474]">
            <Link to="/" className="hover:text-[#222E1D]">
              Forside
            </Link>
            <span>/</span>
            <Link to="/healing" className="hover:text-[#222E1D]">
              Healing
            </Link>
            <span>/</span>
            <span className="font-medium text-[#222E1D]">Behandling over telefon</span>
          </nav>

          <h1 className="font-serif text-3.5xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D] tracking-tight">
            Behandling over telefon
          </h1>

          <p className="text-base sm:text-lg text-[#4D5E46] leading-relaxed">
            Samtale/intuitiv vejledning kombineret med fjernhealing over telefon. (Evt facetime efter ønske).
          </p>
        </div>

        {/* Hero Image */}
        <div className="overflow-hidden rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] shadow-sm">
          <img
            src="/cdn-cgi/image/width=1200,quality=85,format=auto/_assets/cat-1020-scaled.jpg"
            alt="Behandling over telefon - Trine Rosendal"
            className="h-[320px] sm:h-[440px] w-full object-cover"
            onError={(e) => {
              e.currentTarget.src =
                'https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1020-scaled.jpg'
            }}
          />
        </div>

        {/* Content Box with Scrape Prices */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-8 space-y-6">
            <div className="rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-10 shadow-xs space-y-6">
              <div>
                <h2 className="font-serif text-2xl font-medium text-[#222E1D] mb-2">
                  Behandling over telefon
                </h2>
                <p className="text-sm text-[#4D5E46] leading-relaxed">
                  Samtale/intuitiv vejledning kombineret med fjernhealing over telefon. (Evt facetime efter ønske)
                </p>
                <p className="text-xs text-[#5C6E52] mt-1">
                  Der er afsat en time.
                </p>
              </div>

              {/* Price list from scrape */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                <div className="rounded-2xl border-2 border-[#ECC572] bg-gradient-to-br from-[#FFFDF7] to-[#FEF8E8] p-5 space-y-1 shadow-xs">
                  <span className="text-xs font-semibold uppercase tracking-wider text-[#935D08]">
                    60 minutter
                  </span>
                  <p className="font-serif text-2xl font-medium text-[#222E1D]">
                    900,- DKK
                  </p>
                  <p className="text-xs text-[#5C503D]">
                    Samtale og fjernhealing
                  </p>
                </div>

                <div className="rounded-2xl border-2 border-[#ECC572] bg-gradient-to-br from-[#FFFDF7] to-[#FEF8E8] p-5 space-y-1 shadow-xs">
                  <span className="text-xs font-semibold uppercase tracking-wider text-[#935D08]">
                    120 minutter
                  </span>
                  <p className="font-serif text-2xl font-medium text-[#222E1D]">
                    1.100,- DKK
                  </p>
                  <p className="text-xs text-[#5C503D]">
                    Dybdegående samtale og fjernhealing
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="https://system.easypractice.net/book/online-booking-16"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#5C7A4F] px-7 py-3.5 text-sm font-medium text-white shadow-sm transition hover:bg-[#455C3A]"
              >
                <i className="fa-solid fa-calendar-check text-xs text-[#E9D9E5]" aria-hidden="true" />
                <span>Book telefonisk behandling</span>
              </a>

              <a
                href="tel:42510105"
                className="inline-flex items-center gap-2 rounded-full border border-[#DFE6D5] bg-[#F6F8F3] px-6 py-3.5 text-sm font-medium text-[#3E4E36] transition hover:bg-[#EEF4E9] whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-xs text-[#556B48]" aria-hidden="true" />
                <span className="whitespace-nowrap">Ring for aftale: 42 51 01 05</span>
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="rounded-2xl border border-[#DFE6D5] bg-[#F6F8F3] p-6 space-y-3">
              <h3 className="font-serif text-lg font-medium text-[#2B3824]">
                Hvordan foregår det?
              </h3>
              <p className="text-xs text-[#634E5D] leading-relaxed">
                Vi taler sammen over telefon eller FaceTime, hvor jeg tuner ind på din energi og vejleder dig intuitivt, uanset hvor du befinder dig i landet.
              </p>
            </div>
          </div>
        </div>

        <BookingBanner />
      </div>
    </>
  )
}
